<div class="view-wrapper list-page">
  <dx-data-grid
    class="grid theme-dependent"
    id="transporteurListDataGrid"
    [dataSource]="transporteurs"
    [allowColumnReordering]="true"
    [columnAutoWidth]="true"
    [allowColumnResizing]="true"
    [showBorders]="true"
    (onRowUpdated)="updateTransporteur($event)"
  >
    <!-- Toolbar -->
    <dxo-toolbar>
      <dxi-item location="before">
        <div class="grid-header">Liste des transporteurs</div>
      </dxi-item>
      <dxi-item>
        <div *dxTemplate>
          <dx-button icon="deletetable" hint="Réinitialiser les filtres" stylingMode="text" (onClick)="clearDatagridFilters()"></dx-button>
        </div>
      </dxi-item>
      <dxi-item>
        <div *dxTemplate>
          <dx-button icon="refresh" hint="Rafraîchir" (onClick)="setTransporteurs()"></dx-button>
        </div>
      </dxi-item>
      <dxi-item name="searchPanel"></dxi-item>
    </dxo-toolbar>

    <!-- Options -->
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [enabled]="true" [pageSize]="50"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[50, 100, 150]" [showInfo]="true" [visible]="true"></dxo-pager>
    <dxo-editing [allowUpdating]="true"></dxo-editing>

    <!-- Colonnes -->
    <dxi-column dataField="codeBo" caption="Code" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="designation" caption="Intitulé" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="codeInternational" caption="Code Revatua">
      <dxi-validation-rule type="stringLength" [max]="10" message="Le code Revatua ne peut pas dépasser 10 caractères."></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="partenaireId" caption="Société" cellTemplate="displayPartenaireTemplate" editCellTemplate="editPartenaireTemplate">
      <div *dxTemplate="let cellInfo of 'displayPartenaireTemplate'">
        {{ cellInfo.data.partenaireCodeBo }}<span *ngIf="cellInfo.data.partenaireCodeBo"> - </span>{{ cellInfo.data.partenaireIntitule }}
      </div>

      <!-- SelectBox affiché lors de l'édition de la ligne -->
      <div *dxTemplate="let cellInfo of 'editPartenaireTemplate'">
        <dx-select-box
          [dataSource]="partenaireDataSource"
          [searchEnabled]="true"
          [showClearButton]="true"
          [searchExpr]="['intitule', 'codeBo']"
          [showDataBeforeSearch]="true"
          valueExpr="id"
          displayExpr="intitule"
          value="{{cellInfo.data.partenaireId}}"
          selectedItem="{{cellInfo.data.partenaireId}}"
          (onValueChanged)="cellInfo.setValue($event.value)"
        ></dx-select-box>
      </div>
    </dxi-column>
  </dx-data-grid>
</div>